// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypesPriority } from './TypesPriority';
import {
  TypesPriorityFromJSON,
  TypesPriorityFromJSONTyped,
  TypesPriorityToJSON,
  TypesPriorityToJSONTyped,
} from './TypesPriority';
import type { TypesOperator } from './TypesOperator';
import {
  TypesOperatorFromJSON,
  TypesOperatorFromJSONTyped,
  TypesOperatorToJSON,
  TypesOperatorToJSONTyped,
} from './TypesOperator';
import type { TypesServerStatus } from './TypesServerStatus';
import {
  TypesServerStatusFromJSON,
  TypesServerStatusFromJSONTyped,
  TypesServerStatusToJSON,
  TypesServerStatusToJSONTyped,
} from './TypesServerStatus';
import type { TypesNeo4jPlugin } from './TypesNeo4jPlugin';
import {
  TypesNeo4jPluginFromJSON,
  TypesNeo4jPluginFromJSONTyped,
  TypesNeo4jPluginToJSON,
  TypesNeo4jPluginToJSONTyped,
} from './TypesNeo4jPlugin';
import type { TypesAppliedSettings } from './TypesAppliedSettings';
import {
  TypesAppliedSettingsFromJSON,
  TypesAppliedSettingsFromJSONTyped,
  TypesAppliedSettingsToJSON,
  TypesAppliedSettingsToJSONTyped,
} from './TypesAppliedSettings';
import type { TypesCrossClusterReplicationFromConfig } from './TypesCrossClusterReplicationFromConfig';
import {
  TypesCrossClusterReplicationFromConfigFromJSON,
  TypesCrossClusterReplicationFromConfigFromJSONTyped,
  TypesCrossClusterReplicationFromConfigToJSON,
  TypesCrossClusterReplicationFromConfigToJSONTyped,
} from './TypesCrossClusterReplicationFromConfig';
import type { TypesSingleInstanceStatus } from './TypesSingleInstanceStatus';
import {
  TypesSingleInstanceStatusFromJSON,
  TypesSingleInstanceStatusFromJSONTyped,
  TypesSingleInstanceStatusToJSON,
  TypesSingleInstanceStatusToJSONTyped,
} from './TypesSingleInstanceStatus';
import type { TypesStorageClassSettings } from './TypesStorageClassSettings';
import {
  TypesStorageClassSettingsFromJSON,
  TypesStorageClassSettingsFromJSONTyped,
  TypesStorageClassSettingsToJSON,
  TypesStorageClassSettingsToJSONTyped,
} from './TypesStorageClassSettings';
import type { TypesNeo4jDatabaseSizes } from './TypesNeo4jDatabaseSizes';
import {
  TypesNeo4jDatabaseSizesFromJSON,
  TypesNeo4jDatabaseSizesFromJSONTyped,
  TypesNeo4jDatabaseSizesToJSON,
  TypesNeo4jDatabaseSizesToJSONTyped,
} from './TypesNeo4jDatabaseSizes';
import type { TypesInternalDatabaseMetadata } from './TypesInternalDatabaseMetadata';
import {
  TypesInternalDatabaseMetadataFromJSON,
  TypesInternalDatabaseMetadataFromJSONTyped,
  TypesInternalDatabaseMetadataToJSON,
  TypesInternalDatabaseMetadataToJSONTyped,
} from './TypesInternalDatabaseMetadata';
import type { TypesClusterStatus } from './TypesClusterStatus';
import {
  TypesClusterStatusFromJSON,
  TypesClusterStatusFromJSONTyped,
  TypesClusterStatusToJSON,
  TypesClusterStatusToJSONTyped,
} from './TypesClusterStatus';
import type { V1RaftStatus } from './V1RaftStatus';
import {
  V1RaftStatusFromJSON,
  V1RaftStatusFromJSONTyped,
  V1RaftStatusToJSON,
  V1RaftStatusToJSONTyped,
} from './V1RaftStatus';
import type { AdminApiV2TypesCondition } from './AdminApiV2TypesCondition';
import {
  AdminApiV2TypesConditionFromJSON,
  AdminApiV2TypesConditionFromJSONTyped,
  AdminApiV2TypesConditionToJSON,
  AdminApiV2TypesConditionToJSONTyped,
} from './AdminApiV2TypesCondition';
import type { TypesCloudProvider } from './TypesCloudProvider';
import {
  TypesCloudProviderFromJSON,
  TypesCloudProviderFromJSONTyped,
  TypesCloudProviderToJSON,
  TypesCloudProviderToJSONTyped,
} from './TypesCloudProvider';
import type { TypesSourceBackup } from './TypesSourceBackup';
import {
  TypesSourceBackupFromJSON,
  TypesSourceBackupFromJSONTyped,
  TypesSourceBackupToJSON,
  TypesSourceBackupToJSONTyped,
} from './TypesSourceBackup';
import type { V1UnifiedServerStatus } from './V1UnifiedServerStatus';
import {
  V1UnifiedServerStatusFromJSON,
  V1UnifiedServerStatusFromJSONTyped,
  V1UnifiedServerStatusToJSON,
  V1UnifiedServerStatusToJSONTyped,
} from './V1UnifiedServerStatus';
import type { TypesNeo4jDatabaseCounts } from './TypesNeo4jDatabaseCounts';
import {
  TypesNeo4jDatabaseCountsFromJSON,
  TypesNeo4jDatabaseCountsFromJSONTyped,
  TypesNeo4jDatabaseCountsToJSON,
  TypesNeo4jDatabaseCountsToJSONTyped,
} from './TypesNeo4jDatabaseCounts';
import type { V1ShowDatabasesStatus } from './V1ShowDatabasesStatus';
import {
  V1ShowDatabasesStatusFromJSON,
  V1ShowDatabasesStatusFromJSONTyped,
  V1ShowDatabasesStatusToJSON,
  V1ShowDatabasesStatusToJSONTyped,
} from './V1ShowDatabasesStatus';
import type { V1IPAccessControlDefault } from './V1IPAccessControlDefault';
import {
  V1IPAccessControlDefaultFromJSON,
  V1IPAccessControlDefaultFromJSONTyped,
  V1IPAccessControlDefaultToJSON,
  V1IPAccessControlDefaultToJSONTyped,
} from './V1IPAccessControlDefault';
import type { V1StorageClassParameters } from './V1StorageClassParameters';
import {
  V1StorageClassParametersFromJSON,
  V1StorageClassParametersFromJSONTyped,
  V1StorageClassParametersToJSON,
  V1StorageClassParametersToJSONTyped,
} from './V1StorageClassParameters';

/**
 *
 * @export
 * @interface TypesDatabase
 */
export interface TypesDatabase {
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  alias?: string;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  allowChaos?: boolean;
  /**
   *
   * @type {TypesAppliedSettings}
   * @memberof TypesDatabase
   */
  appliedSettings?: TypesAppliedSettings;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  auraInstanceId?: string;
  /**
   *
   * @type {number}
   * @memberof TypesDatabase
   */
  backupFrequencyMinutes?: number;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  backupInProgress?: boolean;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  backupMemoryOverride?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  billingIdentity?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  boltUrl?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  browserUrl?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  cDCEnrichmentMode?: string;
  /**
   *
   * @type {TypesCloudProvider}
   * @memberof TypesDatabase
   */
  cloudProvider?: TypesCloudProvider;
  /**
   * Deprecated: use ClusterStatuses instead
   * @type {TypesClusterStatus}
   * @memberof TypesDatabase
   */
  clusterStatus?: TypesClusterStatus;
  /**
   *
   * @type {{ [key: string]: TypesClusterStatus; }}
   * @memberof TypesDatabase
   */
  clusterStatuses?: { [key: string]: TypesClusterStatus };
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof TypesDatabase
   */
  conditions?: { [key: string]: boolean };
  /**
   *
   * @type {{ [key: string]: AdminApiV2TypesCondition; }}
   * @memberof TypesDatabase
   */
  conditionsV2?: { [key: string]: AdminApiV2TypesCondition };
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  consistencyChecks?: boolean;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  consoleTenantId?: string;
  /**
   *
   * @type {TypesNeo4jDatabaseCounts}
   * @memberof TypesDatabase
   */
  counts?: TypesNeo4jDatabaseCounts;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  createTime?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  createdBy?: string;
  /**
   *
   * @type {TypesCrossClusterReplicationFromConfig}
   * @memberof TypesDatabase
   */
  crossClusterReplicationFromConfig?: TypesCrossClusterReplicationFromConfig;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesDatabase
   */
  cypherRoles?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  cypherVersion?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  darConfig?: string;
  /**
   *
   * @type {TypesNeo4jDatabaseSizes}
   * @memberof TypesDatabase
   */
  databaseSizes?: TypesNeo4jDatabaseSizes;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  databaseStatus?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  databaseType?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  dbId?: string;
  /**
   *
   * @type {V1StorageClassParameters}
   * @memberof TypesDatabase
   */
  diskParameters?: V1StorageClassParameters;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  experimental?: boolean;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  extraConfig?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesDatabase
   */
  features?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  hostClusterId?: string;
  /**
   *
   * @type {V1IPAccessControlDefault}
   * @memberof TypesDatabase
   */
  iPAccessControlDefault?: V1IPAccessControlDefault;
  /**
   *
   * @type {TypesInternalDatabaseMetadata}
   * @memberof TypesDatabase
   */
  internalDatabaseMetadata?: TypesInternalDatabaseMetadata;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  isolationId?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  lastCompletedBackupTime?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  lastUserActivityTime?: string;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  loadDataSuccessful?: boolean;
  /**
   * Deprecated
   * @type {string}
   * @memberof TypesDatabase
   */
  monitoringStatus?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  neo4jMajorVersion?: string;
  /**
   *
   * @type {Array<TypesNeo4jPlugin>}
   * @memberof TypesDatabase
   */
  neo4jPlugins?: Array<TypesNeo4jPlugin>;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  neo4jVersion?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  offlineMaintenance?: string;
  /**
   *
   * @type {TypesOperator}
   * @memberof TypesDatabase
   */
  operator?: TypesOperator;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  orchestra?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  owner?: string;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  packingEfficiency?: boolean;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  pause?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof TypesDatabase
   */
  plugins?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof TypesDatabase
   */
  primariesCount?: number;
  /**
   *
   * @type {TypesPriority}
   * @memberof TypesDatabase
   */
  priority?: TypesPriority;
  /**
   *
   * @type {number}
   * @memberof TypesDatabase
   */
  propertyShardReplicas?: number;
  /**
   *
   * @type {number}
   * @memberof TypesDatabase
   */
  propertyShardsCount?: number;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  quarantined?: boolean;
  /**
   *
   * @type {{ [key: string]: V1RaftStatus; }}
   * @memberof TypesDatabase
   */
  raftStatuses?: { [key: string]: V1RaftStatus };
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  ram?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  resumeTime?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  rollStrategy?: string;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  rollWithoutSeeding?: boolean;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  sSOConfig?: string;
  /**
   *
   * @type {number}
   * @memberof TypesDatabase
   */
  secondariesCount?: number;
  /**
   *
   * @type {Array<V1ShowDatabasesStatus>}
   * @memberof TypesDatabase
   */
  showDatabasesStatus?: Array<V1ShowDatabasesStatus>;
  /**
   *
   * @type {Array<TypesServerStatus>}
   * @memberof TypesDatabase
   */
  showServersStatus?: Array<TypesServerStatus>;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  singleInstance?: boolean;
  /**
   *
   * @type {TypesSingleInstanceStatus}
   * @memberof TypesDatabase
   */
  singleInstanceStatus?: TypesSingleInstanceStatus;
  /**
   *
   * @type {TypesSourceBackup}
   * @memberof TypesDatabase
   */
  sourceBackup?: TypesSourceBackup;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  spdEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  statusUrl?: string;
  /**
   *
   * @type {TypesStorageClassSettings}
   * @memberof TypesDatabase
   */
  storageClassSettings?: TypesStorageClassSettings;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  systemDatabaseLeader?: string;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  tenantDatabase?: boolean;
  /**
   *
   * @type {Array<V1UnifiedServerStatus>}
   * @memberof TypesDatabase
   */
  unifiedServerStatuses?: Array<V1UnifiedServerStatus>;
  /**
   * This field is never updated
   * @type {string}
   * @memberof TypesDatabase
   */
  updateTime?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  userDatabaseLeader?: string;
  /**
   *
   * @type {string}
   * @memberof TypesDatabase
   */
  userDatabaseName?: string;
  /**
   *
   * @type {boolean}
   * @memberof TypesDatabase
   */
  vectorOptimized?: boolean;
  /**
   * Maybe not the best name, but it is consistent with AppliedSettings.VirtSize
   * @type {number}
   * @memberof TypesDatabase
   */
  virtSize?: number;
}

/**
 * Check if a given object implements the TypesDatabase interface.
 */
export function instanceOfTypesDatabase(value: object): value is TypesDatabase {
  return true;
}

export function TypesDatabaseFromJSON(json: any): TypesDatabase {
  return TypesDatabaseFromJSONTyped(json, false);
}

export function TypesDatabaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesDatabase {
  if (json == null) {
    return json;
  }
  return {
    alias: json['Alias'] == null ? undefined : json['Alias'],
    allowChaos: json['AllowChaos'] == null ? undefined : json['AllowChaos'],
    appliedSettings:
      json['AppliedSettings'] == null
        ? undefined
        : TypesAppliedSettingsFromJSON(json['AppliedSettings']),
    auraInstanceId:
      json['AuraInstanceId'] == null ? undefined : json['AuraInstanceId'],
    backupFrequencyMinutes:
      json['BackupFrequencyMinutes'] == null
        ? undefined
        : json['BackupFrequencyMinutes'],
    backupInProgress:
      json['BackupInProgress'] == null ? undefined : json['BackupInProgress'],
    backupMemoryOverride:
      json['BackupMemoryOverride'] == null
        ? undefined
        : json['BackupMemoryOverride'],
    billingIdentity:
      json['BillingIdentity'] == null ? undefined : json['BillingIdentity'],
    boltUrl: json['BoltUrl'] == null ? undefined : json['BoltUrl'],
    browserUrl: json['BrowserUrl'] == null ? undefined : json['BrowserUrl'],
    cDCEnrichmentMode:
      json['CDCEnrichmentMode'] == null ? undefined : json['CDCEnrichmentMode'],
    cloudProvider:
      json['CloudProvider'] == null
        ? undefined
        : TypesCloudProviderFromJSON(json['CloudProvider']),
    clusterStatus:
      json['ClusterStatus'] == null
        ? undefined
        : TypesClusterStatusFromJSON(json['ClusterStatus']),
    clusterStatuses:
      json['ClusterStatuses'] == null
        ? undefined
        : mapValues(json['ClusterStatuses'], TypesClusterStatusFromJSON),
    conditions: json['Conditions'] == null ? undefined : json['Conditions'],
    conditionsV2:
      json['ConditionsV2'] == null
        ? undefined
        : mapValues(json['ConditionsV2'], AdminApiV2TypesConditionFromJSON),
    consistencyChecks:
      json['ConsistencyChecks'] == null ? undefined : json['ConsistencyChecks'],
    consoleTenantId:
      json['ConsoleTenantId'] == null ? undefined : json['ConsoleTenantId'],
    counts:
      json['Counts'] == null
        ? undefined
        : TypesNeo4jDatabaseCountsFromJSON(json['Counts']),
    createTime: json['CreateTime'] == null ? undefined : json['CreateTime'],
    createdBy: json['CreatedBy'] == null ? undefined : json['CreatedBy'],
    crossClusterReplicationFromConfig:
      json['CrossClusterReplicationFromConfig'] == null
        ? undefined
        : TypesCrossClusterReplicationFromConfigFromJSON(
            json['CrossClusterReplicationFromConfig'],
          ),
    cypherRoles: json['CypherRoles'] == null ? undefined : json['CypherRoles'],
    cypherVersion:
      json['CypherVersion'] == null ? undefined : json['CypherVersion'],
    darConfig: json['DarConfig'] == null ? undefined : json['DarConfig'],
    databaseSizes:
      json['DatabaseSizes'] == null
        ? undefined
        : TypesNeo4jDatabaseSizesFromJSON(json['DatabaseSizes']),
    databaseStatus:
      json['DatabaseStatus'] == null ? undefined : json['DatabaseStatus'],
    databaseType:
      json['DatabaseType'] == null ? undefined : json['DatabaseType'],
    dbId: json['DbId'] == null ? undefined : json['DbId'],
    diskParameters:
      json['DiskParameters'] == null
        ? undefined
        : V1StorageClassParametersFromJSON(json['DiskParameters']),
    experimental:
      json['Experimental'] == null ? undefined : json['Experimental'],
    extraConfig: json['ExtraConfig'] == null ? undefined : json['ExtraConfig'],
    features: json['Features'] == null ? undefined : json['Features'],
    hostClusterId:
      json['HostClusterId'] == null ? undefined : json['HostClusterId'],
    iPAccessControlDefault:
      json['IPAccessControlDefault'] == null
        ? undefined
        : V1IPAccessControlDefaultFromJSON(json['IPAccessControlDefault']),
    internalDatabaseMetadata:
      json['InternalDatabaseMetadata'] == null
        ? undefined
        : TypesInternalDatabaseMetadataFromJSON(
            json['InternalDatabaseMetadata'],
          ),
    isolationId: json['IsolationId'] == null ? undefined : json['IsolationId'],
    lastCompletedBackupTime:
      json['LastCompletedBackupTime'] == null
        ? undefined
        : json['LastCompletedBackupTime'],
    lastUserActivityTime:
      json['LastUserActivityTime'] == null
        ? undefined
        : json['LastUserActivityTime'],
    loadDataSuccessful:
      json['LoadDataSuccessful'] == null
        ? undefined
        : json['LoadDataSuccessful'],
    monitoringStatus:
      json['MonitoringStatus'] == null ? undefined : json['MonitoringStatus'],
    neo4jMajorVersion:
      json['Neo4jMajorVersion'] == null ? undefined : json['Neo4jMajorVersion'],
    neo4jPlugins:
      json['Neo4jPlugins'] == null
        ? undefined
        : (json['Neo4jPlugins'] as Array<any>).map(TypesNeo4jPluginFromJSON),
    neo4jVersion:
      json['Neo4jVersion'] == null ? undefined : json['Neo4jVersion'],
    offlineMaintenance:
      json['OfflineMaintenance'] == null
        ? undefined
        : json['OfflineMaintenance'],
    operator:
      json['Operator'] == null
        ? undefined
        : TypesOperatorFromJSON(json['Operator']),
    orchestra: json['Orchestra'] == null ? undefined : json['Orchestra'],
    owner: json['Owner'] == null ? undefined : json['Owner'],
    packingEfficiency:
      json['PackingEfficiency'] == null ? undefined : json['PackingEfficiency'],
    pause: json['Pause'] == null ? undefined : json['Pause'],
    plugins: json['Plugins'] == null ? undefined : json['Plugins'],
    primariesCount:
      json['PrimariesCount'] == null ? undefined : json['PrimariesCount'],
    priority:
      json['Priority'] == null
        ? undefined
        : TypesPriorityFromJSON(json['Priority']),
    propertyShardReplicas:
      json['PropertyShardReplicas'] == null
        ? undefined
        : json['PropertyShardReplicas'],
    propertyShardsCount:
      json['PropertyShardsCount'] == null
        ? undefined
        : json['PropertyShardsCount'],
    quarantined: json['Quarantined'] == null ? undefined : json['Quarantined'],
    raftStatuses:
      json['RaftStatuses'] == null
        ? undefined
        : mapValues(json['RaftStatuses'], V1RaftStatusFromJSON),
    ram: json['Ram'] == null ? undefined : json['Ram'],
    region: json['Region'] == null ? undefined : json['Region'],
    resumeTime: json['ResumeTime'] == null ? undefined : json['ResumeTime'],
    rollStrategy:
      json['RollStrategy'] == null ? undefined : json['RollStrategy'],
    rollWithoutSeeding:
      json['RollWithoutSeeding'] == null
        ? undefined
        : json['RollWithoutSeeding'],
    sSOConfig: json['SSOConfig'] == null ? undefined : json['SSOConfig'],
    secondariesCount:
      json['SecondariesCount'] == null ? undefined : json['SecondariesCount'],
    showDatabasesStatus:
      json['ShowDatabasesStatus'] == null
        ? undefined
        : (json['ShowDatabasesStatus'] as Array<any>).map(
            V1ShowDatabasesStatusFromJSON,
          ),
    showServersStatus:
      json['ShowServersStatus'] == null
        ? undefined
        : (json['ShowServersStatus'] as Array<any>).map(
            TypesServerStatusFromJSON,
          ),
    singleInstance:
      json['SingleInstance'] == null ? undefined : json['SingleInstance'],
    singleInstanceStatus:
      json['SingleInstanceStatus'] == null
        ? undefined
        : TypesSingleInstanceStatusFromJSON(json['SingleInstanceStatus']),
    sourceBackup:
      json['SourceBackup'] == null
        ? undefined
        : TypesSourceBackupFromJSON(json['SourceBackup']),
    spdEnabled: json['SpdEnabled'] == null ? undefined : json['SpdEnabled'],
    statusUrl: json['StatusUrl'] == null ? undefined : json['StatusUrl'],
    storageClassSettings:
      json['StorageClassSettings'] == null
        ? undefined
        : TypesStorageClassSettingsFromJSON(json['StorageClassSettings']),
    systemDatabaseLeader:
      json['SystemDatabaseLeader'] == null
        ? undefined
        : json['SystemDatabaseLeader'],
    tenantDatabase:
      json['TenantDatabase'] == null ? undefined : json['TenantDatabase'],
    unifiedServerStatuses:
      json['UnifiedServerStatuses'] == null
        ? undefined
        : (json['UnifiedServerStatuses'] as Array<any>).map(
            V1UnifiedServerStatusFromJSON,
          ),
    updateTime: json['UpdateTime'] == null ? undefined : json['UpdateTime'],
    userDatabaseLeader:
      json['UserDatabaseLeader'] == null
        ? undefined
        : json['UserDatabaseLeader'],
    userDatabaseName:
      json['UserDatabaseName'] == null ? undefined : json['UserDatabaseName'],
    vectorOptimized:
      json['VectorOptimized'] == null ? undefined : json['VectorOptimized'],
    virtSize: json['VirtSize'] == null ? undefined : json['VirtSize'],
  };
}

export function TypesDatabaseToJSON(json: any): TypesDatabase {
  return TypesDatabaseToJSONTyped(json, false);
}

export function TypesDatabaseToJSONTyped(
  value?: TypesDatabase | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Alias: value['alias'],
    AllowChaos: value['allowChaos'],
    AppliedSettings: TypesAppliedSettingsToJSON(value['appliedSettings']),
    AuraInstanceId: value['auraInstanceId'],
    BackupFrequencyMinutes: value['backupFrequencyMinutes'],
    BackupInProgress: value['backupInProgress'],
    BackupMemoryOverride: value['backupMemoryOverride'],
    BillingIdentity: value['billingIdentity'],
    BoltUrl: value['boltUrl'],
    BrowserUrl: value['browserUrl'],
    CDCEnrichmentMode: value['cDCEnrichmentMode'],
    CloudProvider: TypesCloudProviderToJSON(value['cloudProvider']),
    ClusterStatus: TypesClusterStatusToJSON(value['clusterStatus']),
    ClusterStatuses:
      value['clusterStatuses'] == null
        ? undefined
        : mapValues(value['clusterStatuses'], TypesClusterStatusToJSON),
    Conditions: value['conditions'],
    ConditionsV2:
      value['conditionsV2'] == null
        ? undefined
        : mapValues(value['conditionsV2'], AdminApiV2TypesConditionToJSON),
    ConsistencyChecks: value['consistencyChecks'],
    ConsoleTenantId: value['consoleTenantId'],
    Counts: TypesNeo4jDatabaseCountsToJSON(value['counts']),
    CreateTime: value['createTime'],
    CreatedBy: value['createdBy'],
    CrossClusterReplicationFromConfig:
      TypesCrossClusterReplicationFromConfigToJSON(
        value['crossClusterReplicationFromConfig'],
      ),
    CypherRoles: value['cypherRoles'],
    CypherVersion: value['cypherVersion'],
    DarConfig: value['darConfig'],
    DatabaseSizes: TypesNeo4jDatabaseSizesToJSON(value['databaseSizes']),
    DatabaseStatus: value['databaseStatus'],
    DatabaseType: value['databaseType'],
    DbId: value['dbId'],
    DiskParameters: V1StorageClassParametersToJSON(value['diskParameters']),
    Experimental: value['experimental'],
    ExtraConfig: value['extraConfig'],
    Features: value['features'],
    HostClusterId: value['hostClusterId'],
    IPAccessControlDefault: V1IPAccessControlDefaultToJSON(
      value['iPAccessControlDefault'],
    ),
    InternalDatabaseMetadata: TypesInternalDatabaseMetadataToJSON(
      value['internalDatabaseMetadata'],
    ),
    IsolationId: value['isolationId'],
    LastCompletedBackupTime: value['lastCompletedBackupTime'],
    LastUserActivityTime: value['lastUserActivityTime'],
    LoadDataSuccessful: value['loadDataSuccessful'],
    MonitoringStatus: value['monitoringStatus'],
    Neo4jMajorVersion: value['neo4jMajorVersion'],
    Neo4jPlugins:
      value['neo4jPlugins'] == null
        ? undefined
        : (value['neo4jPlugins'] as Array<any>).map(TypesNeo4jPluginToJSON),
    Neo4jVersion: value['neo4jVersion'],
    OfflineMaintenance: value['offlineMaintenance'],
    Operator: TypesOperatorToJSON(value['operator']),
    Orchestra: value['orchestra'],
    Owner: value['owner'],
    PackingEfficiency: value['packingEfficiency'],
    Pause: value['pause'],
    Plugins: value['plugins'],
    PrimariesCount: value['primariesCount'],
    Priority: TypesPriorityToJSON(value['priority']),
    PropertyShardReplicas: value['propertyShardReplicas'],
    PropertyShardsCount: value['propertyShardsCount'],
    Quarantined: value['quarantined'],
    RaftStatuses:
      value['raftStatuses'] == null
        ? undefined
        : mapValues(value['raftStatuses'], V1RaftStatusToJSON),
    Ram: value['ram'],
    Region: value['region'],
    ResumeTime: value['resumeTime'],
    RollStrategy: value['rollStrategy'],
    RollWithoutSeeding: value['rollWithoutSeeding'],
    SSOConfig: value['sSOConfig'],
    SecondariesCount: value['secondariesCount'],
    ShowDatabasesStatus:
      value['showDatabasesStatus'] == null
        ? undefined
        : (value['showDatabasesStatus'] as Array<any>).map(
            V1ShowDatabasesStatusToJSON,
          ),
    ShowServersStatus:
      value['showServersStatus'] == null
        ? undefined
        : (value['showServersStatus'] as Array<any>).map(
            TypesServerStatusToJSON,
          ),
    SingleInstance: value['singleInstance'],
    SingleInstanceStatus: TypesSingleInstanceStatusToJSON(
      value['singleInstanceStatus'],
    ),
    SourceBackup: TypesSourceBackupToJSON(value['sourceBackup']),
    SpdEnabled: value['spdEnabled'],
    StatusUrl: value['statusUrl'],
    StorageClassSettings: TypesStorageClassSettingsToJSON(
      value['storageClassSettings'],
    ),
    SystemDatabaseLeader: value['systemDatabaseLeader'],
    TenantDatabase: value['tenantDatabase'],
    UnifiedServerStatuses:
      value['unifiedServerStatuses'] == null
        ? undefined
        : (value['unifiedServerStatuses'] as Array<any>).map(
            V1UnifiedServerStatusToJSON,
          ),
    UpdateTime: value['updateTime'],
    UserDatabaseLeader: value['userDatabaseLeader'],
    UserDatabaseName: value['userDatabaseName'],
    VectorOptimized: value['vectorOptimized'],
    VirtSize: value['virtSize'],
  };
}
